import { useEffect, useMemo, useState } from 'react';

export const withQuantity = (WrappedComponent) => {
  return (props) => {
    const { value, controllers, index } = props;
    const { editRow } = controllers;

    const [data, setData] = useState({ quantity: { value } });

    useEffect(() => {
      if (data?.quantity?.touched) {
        editRow(index, 'quantity', data.quantity?.value);
      }
    }, [JSON.stringify(data), index]);

    return <WrappedComponent {...props} data={value} setInputs={setData} key={index} />;
  };
};
